import React, { useState, useRef, useEffect } from "react";
import {
  FaHeart,
  FaCommentDots,
  FaEye,
  FaEllipsisV,
  FaPlus,
} from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";
import GiftStore from "./GiftStore";

export default function VideoSidebar({ video }) {
  const navigate = useNavigate();

  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "null");
  const currentUserEmail = currentUser?.email;

  const isMyVideo =
    video.user_email === currentUserEmail ||
    video.email === currentUserEmail;

  const [showMenu, setShowMenu] = useState(false);
  const [isFollowing, setIsFollowing] = useState(false);
  const [showGifts, setShowGifts] = useState(false);

  const menuRef = useRef();

  // ======================================================
  // Vérifier si je follow déjà
  // ======================================================
  useEffect(() => {
    if (!currentUserEmail || isMyVideo || !video.user_pseudo) return;

    axios
      .get(
        `${API_BASE_URL}/users/is-following/${encodeURIComponent(
          currentUserEmail
        )}/${encodeURIComponent(video.user_pseudo)}`
      )
      .then((res) => {
        setIsFollowing(res.data?.isFollowing === true);
      })
      .catch(() => setIsFollowing(false));
  }, [currentUserEmail, video.user_pseudo, isMyVideo]);

  // ======================================================
  // FOLLOW
  // ======================================================
  const handleFollow = async () => {
    if (!video.user_email) return;

    try {
      await axios.post(`${API_BASE_URL}/users/follow`, {
        followerEmail: currentUserEmail,
        followingEmail: video.user_email,
      });

      setIsFollowing(true);
    } catch (err) {
      console.error("❌ Erreur follow :", err);
    }
  };

  // ======================================================
  // CADEAUX
  // ======================================================
  const handleGiftClick = () => {
    if (!currentUserEmail) {
      alert("❌ Connectez-vous pour envoyer un cadeau");
      return;
    }
    setShowGifts(true);
  };

  // ======================================================
  // Avatar utilisateur
  // ======================================================
  const avatarPath = video.user_profile_picture
    ? video.user_profile_picture
        .replace(/\\/g, "/")
        .replace(/^uploads\//i, "")
    : "profile_pics/default.png";

  // ======================================================
  // NAVIGER VERS PROFIL
  // ======================================================
  const goToProfile = () => {
    if (!video.user_pseudo) return;
    navigate(`/user/${video.user_pseudo}`);
  };

  return (
    <>
      <div
        style={{
          position: "absolute",
          right: "12px",
          bottom: "100px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          zIndex: 9999,
          pointerEvents: "auto",
          width: "50px",
        }}
      >
        {/* ======================================================
            PROFIL + FOLLOW
        ====================================================== */}

        <div style={{ position: "relative", width: 48, height: 48 }}>
          <img
            src={`${API_BASE_URL}/../uploads/${avatarPath}`}
            alt="profil"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
              border: "2px solid white",
              cursor: "pointer",
            }}
            onClick={goToProfile}
            onError={(e) => {
              e.target.src = "/default-avatar.png";
            }}
          />

          {!isMyVideo && !isFollowing && (
            <div
              onClick={handleFollow}
              style={{
                width: 20,
                height: 20,
                backgroundColor: "#fe2c55",
                borderRadius: "50%",
                position: "absolute",
                bottom: -5,
                left: "50%",
                transform: "translateX(-50%)",
                border: "2px solid white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <FaPlus size={10} color="white" />
            </div>
          )}
        </div>

        {/* ======================================================
            LIKES
        ====================================================== */}

        <div style={{ textAlign: "center", color: "white" }}>
          <FaHeart size={28} />
          <div
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              textShadow: "1px 1px 2px black",
            }}
          >
            {video.likes || 0}
          </div>
        </div>

        {/* ======================================================
            VUES
        ====================================================== */}

        <div style={{ textAlign: "center", color: "white" }}>
          <FaEye size={28} />
          <div
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              textShadow: "1px 1px 2px black",
            }}
          >
            {video.views || 0}
          </div>
        </div>

        {/* ======================================================
            COMMENTAIRES
        ====================================================== */}

        <div style={{ textAlign: "center", color: "white" }}>
          <FaCommentDots size={28} />
          <div
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              textShadow: "1px 1px 2px black",
            }}
          >
            {video.comments_count || 0}
          </div>
        </div>

        {/* ======================================================
            CADEAUX
        ====================================================== */}

        <div
          onClick={handleGiftClick}
          style={{
            fontSize: "30px",
            cursor: "pointer",
            filter: "drop-shadow(1px 1px 2px black)",
          }}
        >
          🎁
        </div>

        {/* ======================================================
            MENU
        ====================================================== */}

        <div ref={menuRef} style={{ position: "relative", color: "white" }}>
          <div onClick={() => setShowMenu(!showMenu)} style={{ cursor: "pointer" }}>
            <FaEllipsisV size={22} />
          </div>

          {showMenu && (
            <div
              style={{
                backgroundColor: "white",
                color: "black",
                borderRadius: "8px",
                padding: "10px",
                position: "absolute",
                bottom: "40px",
                right: "0",
                minWidth: "140px",
                boxShadow: "0px 4px 15px rgba(0,0,0,0.5)",
              }}
            >
              <div
                style={{ padding: "8px", cursor: "pointer" }}
                onClick={() => alert("Lien copié")}
              >
                Partager
              </div>

              <div style={{ padding: "8px", cursor: "pointer" }}>Favori</div>
            </div>
          )}
        </div>
      </div>

      {/* ======================================================
          MODAL CADEAUX
      ====================================================== */}

      {showGifts && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.9)",
            zIndex: 10000,
            display: "flex",
            alignItems: "flex-end",
          }}
          onClick={() => setShowGifts(false)}
        >
          <div
            style={{
              backgroundColor: "#121212",
              width: "100%",
              padding: "20px",
              borderTopLeftRadius: "15px",
              borderTopRightRadius: "15px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <GiftStore
              receiverEmail={video.user_email || video.email}
              videoId={video.id}
              onSent={() => setShowGifts(false)}
            />
          </div>
        </div>
      )}
    </>
  );
}
